<template>
  <div :class="$style.ctn">
    <button
      :disabled="values.length < 3" type="button"
      :class="$style.nav"
      @click="nav(-1)"
      title="To previous image"
    >
      <SvgIcon
        :class="$style.indicator"
        width="10"
        height="20"
        src="icon-sprite.svg#swiper_arrow"
      />
    </button>
    <div ref="content" :class="$style.contentCtn">
      <viewer :images="images" :class="$style.content">
        <FallbackMedia
          v-for="(src, index) in values"
          is="img"
          :key="index"
          :class="$style.image"
          :source="src"
          alt="screenshot"
          @load="setImage($event, index)"
          loading="lazy"
        />
        <div :class="[$style.image, $style.message]">
          <SvgIcon width="34" height="34" src="icon-sprite.svg#information" />
          <span>All screenshots are available in the full report</span>
        </div>
      </viewer>
    </div>
    <button
      :disabled="values.length < 3"
      type="button"
      :class="$style.nav"
      title="To next image"
      style="transform: rotate(180deg)"
      @click="nav(1)"
    >
      <SvgIcon
        :class="$style.indicator"
        width="10"
        height="20"
        src="icon-sprite.svg#swiper_arrow"
      />
    </button>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import 'viewerjs/dist/viewer.css';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import PerfectScrollbar from 'perfect-scrollbar';
import FallbackMedia from './FallbackMedia.vue';

import SvgIcon from './SvgIcon.vue';

export default defineComponent({
  components: {
    SvgIcon,
    FallbackMedia
},
  props: {
    values: { type: Array, required: true },
  },
  data() {
    return {
      perfectScrollbarInstance: null,
      images: new Array(this.values.length).fill(null)
    };
  },
  mounted() {
    this.perfectScrollbarInstance = new PerfectScrollbar(this.$refs.content, {
      useBothWheelAxes: true,
      wheelSpeed: 3,
    });
  },
  methods: {
    nav(direction) {
      this.$refs.content.scrollBy(300 * direction, 0);
    }, 
    setImage(src, index) {
      this.images[index] = src;
    }
  }
});
</script>

<style lang="scss">
.ps__rail-y {
  display: none !important;
}

.ps__rail-y,
.ps__rail-x {
  @media print {
    opacity: 0 !important;
    display: none !important;
  }
}

.ps__rail-x {
  transition: background-color 0.2s linear, opacity 0.2s linear;
  position: absolute;
  height: 3px;
  opacity: 1;
  background-color: rgba(63, 71, 87, 0.1) !important;
  opacity: 1 !important;

  .ps__thumb-x:hover,
  &.ps--clicking .ps__thumb-x {
    background: #3f4757 !important;
  }
}

.ps__thumb-x {
  z-index: 1;
  bottom: 0;
  background: rgba(63, 71, 87, 0.6) !important;
  position: absolute;
  height: 3px !important;
  border-radius: 6px;
  transition: background-color 0.2s linear, height 0.2s ease-in-out;
}
.ps__rail-x,
.ps__thumb-x {
  border-radius: 1.5px;

  &::after {
    height: 13px;
    bottom: 0px;
    content: '';
    left: 0;
    width: 100%;
    position: absolute;
    display: block;
  }
}
</style>
<style lang="scss" module>
.ctn {
  display: flex;
  position: relative;
}
.nav {
  width: 35px;
  display: flex;
  align-items: center;
  // justify-content: center;
  padding-left: 5px;
  flex: none;
  --icon-color: rgba(63, 71, 87, 0.25);
  &:hover {
    --icon-color: rgba(63, 71, 87, 1);
  }
  &:disabled {
    pointer-events: none;
    opacity: 0;
  }

  @media print {
    display: none;
  }
}
.image {
  flex: none;
  width: 330px;
  height: 185px;
  display: block;
  background: rgba(63, 71, 87, 0.09);
  cursor: zoom-in;

  @media print {
    width: 223px;
    height: 125px;
  }
}
.contentCtn {
  width: 100%;
  position: relative;
  overflow: hidden;
  overflow-anchor: none;
  touch-action: auto;
}

.content {
  display: grid;
  grid-auto-flow: column;
  grid-gap: 10px;
  padding-bottom: 13px;

  justify-content: flex-start;

  @media print {
    grid-template-columns: repeat(5, 1fr);
    grid-auto-flow: row;
    grid-gap: 5px;
    padding-bottom: 0;
  }
}

.message {
  cursor: default;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 16px;
  --icon-color: rgba(63, 71, 87, 0.44);
  color: rgba(63, 71, 87, 0.44);
  padding: 0 38px;

  svg {
    flex: none;
    & + * {
      margin-left: 12px;
    }
  }

  @media print {
    display: none;
  }
}
</style>
